import TabNav from "components/TabNav";
import { useAuth } from "contexts/AuthContext";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LEGAL_RESEARCH_PROSECUTOR_TAB,
  LEGAL_RESEARCH_PROSECUTOR_TABS,
  LEGAL_RESEARCH_REQUEST_STATUS,
} from "utils/constantValues";
import LeftPanel from "../fragments/leftPanel";
import RightPanel from "../fragments/rightPanel";

function ProsecutorLegalResearch({ request }: { request: any }) {
  const [activeTab, setActiveTab] = useState<string>("Proposal Document");
  const navigate = useNavigate();
  const { user } = useAuth();

  const [formState, setFormState] = useState({
    ...request,
    urgency_level: request?.urgency_level
      ? request.urgency_level.charAt(0).toUpperCase() +
        request.urgency_level.slice(1).toLowerCase()
      : "High",
  });

  /** -------------------------------
   *  CHECK IF USER IS TEAM LEADER
   *  ------------------------------- */
  const isTeamLeader = useMemo(() => {
    return formState?.research_teams?.some((team: any) =>
      team?.prosecutors?.some(
        (prosecutor: any) =>
          prosecutor?.prosecutor_user_id === user?.user_id &&
          prosecutor?.is_team_leader
      )
    );
  }, [formState, user]);

  /** ---------------------------------
   *  CHECK IF USER HAS ANY TOPICS
   *  --------------------------------- */
  const hasTopics = useMemo(() => {
    return (
      formState?.research_teams
        ?.find((team: any) =>
          team?.prosecutors?.some(
            (prosecutor: any) =>
              prosecutor?.prosecutor_user_id === user?.user_id
          )
        )
        ?.topics?.length > 0
    );
  }, [formState, user]);

  /** ---------------------------------
   *  REDIRECT CONDITION
   *  --------------------------------- */
  const shouldRedirect =
    formState?.requested_by === "internal" &&
    !hasTopics &&
    isTeamLeader;

  /** ---------------------------------
   *  NAVIGATION (SIDE EFFECT)
   *  --------------------------------- */
  useEffect(() => {
    if (shouldRedirect) {
      navigate(
        `/conduct-legal-research/editInternalrequest/${formState.id}`,
        { state: { formState } }
      );
    }
  }, [shouldRedirect, navigate, formState]);

  /** ---------------------------------
   *  RENDER
   *  --------------------------------- */
  if (shouldRedirect) return null;

  return (
    <div className="flex flex-col h-full bg-gray-100">
      {formState?.requested_by !== "internal" && (
        <TabNav
          active={activeTab}
          tabs={
            formState?.status ===
              LEGAL_RESEARCH_REQUEST_STATUS.research_underway.value ||
            formState?.status ===
              LEGAL_RESEARCH_REQUEST_STATUS.draft_submitted.value ||
            formState?.status ===
              LEGAL_RESEARCH_REQUEST_STATUS.draft_revision.value ||
            formState?.status ===
              LEGAL_RESEARCH_REQUEST_STATUS.draft_approved.value ||
            formState?.status ===
              LEGAL_RESEARCH_REQUEST_STATUS.completed.value ||
            formState?.documents?.some(
              (document: any) =>
                document?.document_type === "research_draft_file"
            )
              ? LEGAL_RESEARCH_PROSECUTOR_TABS
              : LEGAL_RESEARCH_PROSECUTOR_TAB
          }
          onSelect={setActiveTab}
        />
      )}

      <div className="flex flex-1 overflow-hidden">
        <LeftPanel activeTab={activeTab} request={request} />
        <RightPanel request={request} />
      </div>
    </div>
  );
}

export default ProsecutorLegalResearch;

